import { render, staticRenderFns } from "./InfoTypesByVirtual.vue?vue&type=template&id=08c54e1f&"
import script from "./InfoTypesByVirtual.vue?vue&type=script&lang=ts&"
export * from "./InfoTypesByVirtual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports